import { create } from 'zustand';
const useEditorStore = create((set) => ({
    editCurve: null,
    setEditCurve: (editCurve) => {
        set({ editCurve });
    },
}));
export default useEditorStore;
